
import { cspNonce } from './nonceSetup';

// eslint-disable-next-line sort-imports
import App from './app';
import { CacheProvider } from '@emotion/react';
import React from 'react';
import ReactDOM from 'react-dom';
import createCache from '@emotion/cache';

const emotionCache = createCache({ key: 'css', nonce: cspNonce });

ReactDOM.render(
    <CacheProvider value={emotionCache}>
        <App />
    </CacheProvider>,
    document.getElementById('root'),
);
